import { isNil } from 'lodash-es';

import { GenericFailure } from '@playq/services-shared';

export const getErrorBrief = (error: GenericFailure | Error): string => {
  const errorMessage = error.message;

  if (error instanceof GenericFailure && !isNil(error.code)) {
    return `Error occurred, details in console. Code: ${error.code}`;
  }

  return errorMessage;
};
